<div class="d-flex justify-content-between align-items-center my-2">
    <div class="d-flex align-items-center">
      <div class="card-sub-heading ml-3 bold">Are you sure to sync medication data from Kroll?</div>
    </div>
  </div>
  <div class=" d-flex mt-4">
    <div class="col-md-12 d-flex justify-content-center ">
      <button class="custom-btn w-100" type="button" (click)="this.dialogRef.close();">Cancel</button>
      <button class="custom-btn w-100" type="button" (click)="yesSubmit()" >Yes</button>
    </div>
  </div>
  